import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    stocksAreVolatile: 'Tokenised Stocks Are Volatile',
    riskDisclosureWarning: {
      capitalAtRisk:
        'Meaning their prices can change quickly. Like with all investments, your capital is at risk.',
      reviewBeforeInvesting:
        'Make sure you have reviewed and understood the following before investing.',
      orderPolicy: 'Order Execution Policy',
      tokenisedStocksRisk: 'Tokenised Stocks Risk Disclosures',
      generalRisk: 'General Risk Disclosures',
    },
  },
  de: {
    stocksAreVolatile: 'Tokenisierte Aktien Sind Volatil',
    riskDisclosureWarning: {
      capitalAtRisk:
        'Das bedeutet, dass sich ihre Preise schnell ändern können. Wie bei allen Investitionen ist dein Kapital einem Risiko ausgesetzt.',
      reviewBeforeInvesting:
        'Stell sicher, dass du Folgendes überprüft und verstanden hast, bevor du investierst.',
      orderPolicy: 'Order Execution Policy',
      tokenisedStocksRisk: 'Tokenised Stocks Risk Disclosures',
      generalRisk: 'General Risk Disclosures',
    },
  },
});
